export const initBlockData = {
  title: "",
  news: '',
};

export const initEmptyBlockData = {
  title: "",
  news: "",
};
